/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Router from 'react-router';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CurateRouter extends React.Component {
	render() {
		let { children, ...otherProps } = this.props;

		return (
			<Outlet context={otherProps}/>
		);
	}
};

CurateRouter.displayName = "CurateRouter";

CurateRouter.propTypes = {
	recordPath: PropTypes.func,
};

CurateRouter.defaultProps = {
	recordPath: () => {},
};

export default ComponentWithContext(CurateRouter);
